module.exports = __webpack_public_path__ + "static/img/video-3.7e31ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-3.jpg
// module id = AZp+
// module chunks = 12